<template>
  <div>
    <ExperimentParticipationSentence/>
    <TextLink text="実証実験に参加" @click-text="onClickAgree" />
    <TextLink text="実証実験に参加しない" @click-text="onClickNotAgree"/>
    <p v-if="isTest">テスト版</p>
  </div>
</template>

<script>
import TextLink from '@/components/Atoms/TextLink'
import ExperimentParticipationSentence from '@/components/Molecules/ExperimentParticipationSentence'

export default {
  name: 'consetn-check',
  components: {
    TextLink,
    ExperimentParticipationSentence
  },
  props: {
    isTest: { type: Boolean }
  },
  methods: {
    onClickAgree () {
      this.$emit('click-ok', true)
    },
    onClickNotAgree () {
      this.$emit('click-ok', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Organisms/ExperimentParticipationCheck.vue